<template>
	<div>
		<!-- 面包屑导航区域 -->		
		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<el-tabs v-model="activeTab" type="border-card">
				<!-- 个人信息标签页 -->
				<el-tab-pane label="个人信息" name="info">
					<div class="info-container">
						<div class="avatar-container">
							<el-avatar :size="120" :src="userInfo.avatar || require('@/assets/image/head.png')"></el-avatar>
							<div class="username">{{ userInfo.username }}</div>
						</div>
						<div class="detail-container">
							<el-descriptions title="基本信息" :column="2" border>
								<el-descriptions-item label="用户名">{{ userInfo.username }}</el-descriptions-item>
								<el-descriptions-item label="昵称">{{ userInfo.nickName }}</el-descriptions-item>
								<el-descriptions-item label="状态">
									<el-tag :type="userInfo.state ? 'danger' : 'success'">
										{{ userInfo.state ? '禁用' : '正常' }}
									</el-tag>
								</el-descriptions-item>
								<el-descriptions-item label="创建时间">{{ userInfo.createTime }}</el-descriptions-item>
								<el-descriptions-item label="更新时间">{{ userInfo.updateTime }}</el-descriptions-item>
							</el-descriptions>
						</div>
					</div>
				</el-tab-pane>
				
				<!-- 修改密码标签页 -->
				<el-tab-pane label="修改密码" name="password">
					<el-form :model="passwordForm" status-icon :rules="passwordRules" ref="passwordForm" label-width="100px" class="password-form">
						<el-form-item label="原密码" prop="oldPassword">
							<el-input type="password" v-model="passwordForm.oldPassword" autocomplete="off" show-password></el-input>
						</el-form-item>
						<el-form-item label="新密码" prop="newPassword">
							<el-input type="password" v-model="passwordForm.newPassword" autocomplete="off" show-password></el-input>
						</el-form-item>
						<el-form-item label="确认密码" prop="confirmPassword">
							<el-input type="password" v-model="passwordForm.confirmPassword" autocomplete="off" show-password></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="submitPasswordForm">提交</el-button>
							<el-button @click="resetPasswordForm">重置</el-button>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		// 验证确认密码
		var validateConfirmPassword = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入新密码'));
			} else if (value !== this.passwordForm.newPassword) {
				callback(new Error('两次输入密码不一致'));
			} else {
				callback();
			}
		};
		
		return {
			activeTab: 'info',
			userInfo: {},
			editDialogVisible: false,
			editForm: {
				userId: '',
				username: '',
				nickName: '',
				birthday: ''
			},
			passwordForm: {
				oldPassword: '',
				newPassword: '',
				confirmPassword: ''
			},
			editRules: {
				nickName: [
					{ required: true, message: '请输入昵称', trigger: 'blur' },
					{ min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
				]
			},
			passwordRules: {
				oldPassword: [
					{ required: true, message: '请输入原密码', trigger: 'blur' }
				],
				newPassword: [
					{ required: true, message: '请输入新密码', trigger: 'blur' },
					{ min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
				],
				confirmPassword: [
					{ validator: validateConfirmPassword, trigger: 'blur' }
				]
			}
		}
	},
	created() {
		this.getUserInfo()
	},
	methods: {
		// 获取当前用户信息
		async getUserInfo() {
			// 从服务器获取最新信息
		try {
			const res = await this.$http.post('system/user/getPersonalInfo')
			if (res.data.code === 200) {
				this.userInfo = res.data.data
			} else {
				this.$message.error('获取用户信息失败')
			}
		} catch (error) {
			console.error('获取用户信息失败:', error)
			this.$message.error('获取用户信息失败')
		}
		},
		// 提交密码修改表单
		submitPasswordForm() {
			this.$refs.passwordForm.validate(async valid => {
				if (!valid) return
				
				try {
				const res = await this.$http.post('system/user/updatePassword', {
					oldPassword: this.passwordForm.oldPassword,
					newPassword: this.passwordForm.newPassword
				})
				if (res.data.code === 200) {
					this.$message.success('密码修改成功')
					this.resetPasswordForm()
				} else {
					this.$message.error(res.data.msg || '密码修改失败')
				}
			} catch (error) {
				this.$message.error('密码修改失败')
			}
			})
		},
		
		// 重置密码表单
		resetPasswordForm() {
			this.$refs.passwordForm.resetFields()
		}
	}
}
</script>

<style scoped>
.info-container {
	display: flex;
	margin-top: 20px;
}

.avatar-container {
	flex: 1;
	text-align: center;
	padding: 20px;
}

.username {
	margin-top: 15px;
	font-size: 18px;
	font-weight: bold;
}

.detail-container {
	flex: 3;
	padding: 20px;
}

.button-container {
	margin-top: 20px;
	text-align: center;
}

.password-form {
	max-width: 500px;
	margin: 20px auto;
	padding: 20px;
	border-radius: 5px;
	background-color: #f9f9f9;
}
</style>